import React, { FC } from "react";
import { IAcompanhamento } from "@deltasge/marauders-map";
import {
  Box,
  Button,
  CircularProgress,
  Paper,
  Typography,
} from "@mui/material";
import {
  InboxOutline as InboxIcon,
  Printer as PrintIcon,
} from "mdi-material-ui";

export const ConselhoTurma: FC<{
  titulo: string;
  pareceres: IAcompanhamento[];
  loading: boolean;
  onImprimir: () => void;
}> = ({ titulo, pareceres, loading, onImprimir }) => {
  const registros = pareceres.filter(
    (parecer) => (parecer.texto ?? "").trim().length > 0
  );
  const hasData = registros.length > 0;

  return (
    <Box>
      <Box
        sx={{
          mb: 3,
          display: "flex",
          justifyContent: "space-between",
          alignItems: "flex-end",
        }}
      >
        <Box>
          <Typography variant="h5" color="primary">
            Conselho de Classe: Análise Coletiva
          </Typography>
          <Typography variant="body2" color="text.secondary">
            {titulo}
          </Typography>
        </Box>
        <Button
          variant="outlined"
          color="primary"
          startIcon={<PrintIcon />}
          onClick={onImprimir}
          disabled={!hasData}
        >
          Imprimir Ata da Turma
        </Button>
      </Box>

      <Paper
        sx={{ p: 4, border: "1px solid #e0e0e0", boxShadow: "none" }}
        variant="outlined"
      >
        {loading ? (
          <Box sx={{ display: "flex", justifyContent: "center", py: 5 }}>
            <CircularProgress />
          </Box>
        ) : hasData ? (
          registros.map((parecer) => (
            <Box key={`ata_turma_${parecer.id}`} sx={{ mb: 4 }}>
              <Typography
                variant="subtitle2"
                fontWeight="bold"
                sx={{
                  color: "#555",
                  textTransform: "uppercase",
                  mb: 1,
                  borderBottom: "1px solid #eee",
                  pb: 1,
                }}
              >
                {parecer.materia?.nome}
              </Typography>
              <Typography
                variant="body1"
                sx={{ color: "#333", whiteSpace: "pre-wrap" }}
              >
                {parecer.texto}
              </Typography>
            </Box>
          ))
        ) : (
          <Box sx={{ textAlign: "center", py: 5, color: "#999" }}>
            <InboxIcon sx={{ fontSize: 48, opacity: 0.3 }} />
            <Typography>
              Nenhum parecer coletivo registrado para esta turma.
            </Typography>
          </Box>
        )}
      </Paper>
    </Box>
  );
};
